/**
 * Hands the module list to core, as context.
 *
 * Core reads modules through this — the route table, the sidebar, every
 * `<Slot>` — and never imports the list. A core file that imported it would
 * import every module, and every module imports core's components; the context
 * is what breaks that cycle. `main.tsx` is the one place the list is imported,
 * as `index.ts` and `cli/program.ts` are on the backend.
 */
import { createContext, type ReactNode } from 'react';
import type { FrontendModule } from './types';

export const ModulesContext = createContext<readonly FrontendModule[]>([]);

export function ModulesProvider({
  modules,
  children,
}: {
  modules: readonly FrontendModule[];
  children: ReactNode;
}) {
  return <ModulesContext.Provider value={modules}>{children}</ModulesContext.Provider>;
}
